import React from 'react'

import ModalBody from 'components/Utils/Modal/Body'
import { Text, Button } from 'components/base'

import Item from './Item'
import SearchBox from './SearchBox'

export default function TemplatesPickerContainerPicker({
  fetchNextPage,
  templateNotes,
  applyTemplateOnNote,
  activeNoteId,
  onModalClose,
}) {
  const [inputValue, setInputValue] = React.useState('')
  const [highlightedIndex, setHighlightedIndex] = React.useState(0)
  const [selectedTemplate, setSelectedTemplate] = React.useState(null)
  const [filteredTemplates, setFilteredTemplates] = React.useState(
    templateNotes
  )

  React.useEffect(
    function onMount() {
      fetchNextPage({ startFresh: true })
    },
    [fetchNextPage]
  )

  React.useEffect(
    () => {
      setHighlightedIndex(0)
      setFilteredTemplates(
        templateNotes.filter(template =>
          template.title.toLowerCase().includes(inputValue.toLocaleLowerCase())
        )
      )
    },
    [inputValue, templateNotes]
  )

  const onApplyTemplate = () => {
    onModalClose()
    applyTemplateOnNote({
      sourceNoteId: selectedTemplate.id,
      destinationNoteId: activeNoteId,
    })
  }

  const onMoveDown = () =>
    highlightedIndex < filteredTemplates.length - 1 &&
    setHighlightedIndex(highlightedIndex + 1)

  const onMoveUp = () =>
    highlightedIndex && setHighlightedIndex(highlightedIndex - 1)

  const onTemplateSelect = () => {
    const templateToApply = filteredTemplates[highlightedIndex]
    if (templateToApply) {
      onModalClose()
      applyTemplateOnNote({
        sourceNoteId: templateToApply.id,
        destinationNoteId: activeNoteId,
      })
    }
  }

  const onClickTemplate = ({ id, index }) => {
    setHighlightedIndex(index)
    setSelectedTemplate(filteredTemplates.find(template => template.id === id))
  }

  return (
    <ModalBody style={{ padding: 24 }}>
      <Text.Title className="line-height-larger margin-bottom-medium">
        Choose a template
      </Text.Title>
      <div className="radius-normal border-small border-shade-40">
        <SearchBox
          value={inputValue}
          onChange={value => setInputValue(value)}
          onEnter={onTemplateSelect}
          onMoveDown={onMoveDown}
          onMoveUp={onMoveUp}
        />
        <div style={{ minHeight: 200, maxHeight: 500 }} className="scroll-y">
          {filteredTemplates.length ? (
            filteredTemplates.map((template, index) => {
              return (
                <Item
                  onClick={onClickTemplate}
                  id={template.id}
                  key={template.id}
                  index={index}
                  selected={index === highlightedIndex}
                >
                  {template.title || 'Untitled template'}
                </Item>
              )
            })
          ) : (
            <Text.Corpus
              className="flexbox flexbox-centered"
              style={{ marginTop: 90 }}
            >
              No result
            </Text.Corpus>
          )}
        </div>
      </div>
      <div className="flexbox margin-top-larger font-weight-medium flexbox-space-between ellipsis">
        <Button.Secondary onClick={onModalClose}>Close</Button.Secondary>
        {selectedTemplate && (
          <Button.Primary onClick={onApplyTemplate}>
            {'Use template'}
          </Button.Primary>
        )}
      </div>
    </ModalBody>
  )
}
